// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section « Commandes complementaires » cote acheteur : bouton au-dessus du tableau partage. */
.bc-complements__actions {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationBCV2/components/CommandesComplementaires.css"],"names":[],"mappings":"AAAA,+FAA+F;AAC/F;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB","sourcesContent":["/* Section « Commandes complementaires » cote acheteur : bouton au-dessus du tableau partage. */\n.bc-complements__actions {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
